module.exports = __webpack_public_path__ + "img/icon-well.1e014651.png";